var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
var collectionHandle = document.getElementsByTagName("BODY")[0].id;
var defaultFileUrl = bcSfFilterConfig.general.file_url.split('?');
// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        /* Optional */
        loadProductFirst: false
    }
};

var available_first_categories = [0,61576020021];

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': ' sold-out',
    'saleClass': ' on-sale',
    'soldOutLabelHtml': '<span class="soldout bc-sf-filter-label">' + bcSfFilterConfig.label_basic.sold_out + '</span>',
    'saleLabelHtml': '<span class="sale bc-sf-filter-label">' + bcSfFilterConfig.label_basic.sale + '</span>',
    'tagLabelHtml': '<span class="tag bc-sf-filter-label {{labelTag}}" >{{labelTag}}</span>',
    'vendorHtml': '<p class="bc-sf-filter-product-item-vendor">{{itemVendorLabel}}</p>',
    // Grid Template
    'productGridItemHtml': '<div class="bc-sf-filter-product-item bc-sf-filter-product-item-grid {{gridWidthClass}}{{soldOutClass}}{{saleClass}} {{itemActiveSwapClass}}">' +
                                '<script class="bc-sf-filter-product-script" data-id="bc-product-json-{{itemId}}" type="application/json">{{itemJson}}</script>' +
                                '<div class="bc-sf-filter-product-item-inner">' +
                                    '<div class="bc-sf-filter-product-item-image">' +
                                        '<a href="{{itemUrl}}" class="bc-sf-filter-product-item-image-link">{{itemImages}}</a>' +
                                    '</div>' +
                                    '<div class="bc-sf-filter-product-item-label">{{itemLabels}}{{itemTagLabels}}</div>' +
                                    '<div class="bc-sf-filter-product-bottom">' +
                                        '<a href="{{itemUrl}}" class="bc-sf-filter-product-item-title">{{itemTitle}}</a>' +
                                        '{{itemVendor}}' +
                                        '{{itemPrice}}' +
                                    '</div>' +
                                '</div>' +
                            '</div>',
    // For List View
    // List Template
    'productListItemHtml': '<div class="bc-sf-filter-product-item bc-sf-filter-product-item-list {{soldOutClass}}{{saleClass}} {{itemActiveSwapClass}}">' +
                                '<div class="bc-sf-filter-product-item-list-col-1">' +
                                    '<div class="bc-sf-filter-product-item-image">' +
                                        '<div class="bc-sf-filter-product-item-label">{{itemLabels}}{{itemTagLabels}}</div>' +
                                        '<a href="{{itemUrl}}" class="bc-sf-filter-product-item-image-link">{{itemImages}}</a>' +
                                    '</div>' +
                                '</div>' +
                                '<div class="bc-sf-filter-product-bottom">' +
                                    '<div class="bc-sf-filter-product-item-list-col-2">' +
                                        '<a href="{{itemUrl}}" class="bc-sf-filter-product-item-title">{{itemTitle}}</a>' +
                                        '{{itemVendor}}' +
                                        '<p class="bc-sf-filter-des">{{itemDescription}}</p>' +
                                    '</div>' +
                                    '<div class="bc-sf-filter-product-item-list-col-3">{{itemPrice}}</div>' +
                                '</div>'+
                            '</div>',
    // End For List View
    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}">Previous</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>Previous</span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}">Next</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>Next</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li class="active"><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul>{{previous}}{{pageItems}}{{next}}</ul>',
    // Sorting Template
    'sortingHtml': '<label>' + bcSfFilterConfig.labels.sorting + '</label><select class="bc-sf-filter-filter-dropdown">{{sortingItems}}</select>',
    // Show Limit Template
    'showLimitHtml': '<label>' + bcSfFilterConfig.labels.show_limit + '</label><select class="bc-sf-filter-filter-dropdown">{{showLimitItems}}</select>',
    // Breadcrumb Template
    'breadcrumbHtml': '<a href="/">' + bcSfFilterConfig.labels.breadcrumb_home + '</a> {{breadcrumbDivider}} {{breadcrumbItems}}',
    'breadcrumbDivider': '<span class="divider">/</span>',
    'breadcrumbItemLink': '<a href="{{itemLink}}">{{itemTitle}}</a>',
    'breadcrumbItemSelected': '<span>{{itemTitle}}</span>',
};
/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
  // Displaying price base on the policy of Shopify, have to multiple by 100
  soldOut = !data.available; // Check a product is out of stock
  onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Convert images to array
  images = data.images_info;
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  return data;
}
/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
/************************** BUILD PRODUCT LIST **************************/
// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  data = prepareShopifyData(data);
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  var itemHtml = '';
  var parentBCDiv = document.getElementById('bc-sf-filter-products');

  if ( parentBCDiv.className.indexOf('product-list') > -1 ) {
    parentBCDiv.className = 'product-collection products-grid row';
  }
  
  var self = this;
  var itemJson = {
    "id": data.id,
    "title": data.title,
    "handle": data.handle,
    "vendor": data.vendor,
    "variants": data.variants,
    "url": self.buildProductItemUrl(data),
    "options_with_values": data.options_with_values,
    "images": data.images,
    "available": data.available,
    "price_min": data.price_min,
    "price_max": data.price_max,
    "compare_at_price_min": data.compare_at_price_min,
    "compare_at_price_max": data.compare_at_price_max
  };

  itemHtml += '<div class="col-6 col-sm-4 col-md-3';
  if ( theme.strings.imageBorder ) {
    itemHtml += 'grid-item-border';
  }
  itemHtml += ' grid-item ';
  itemHtml += document.getElementById('collectionItemGridWith').value + ' page-search">';
  itemHtml += '<div class="inner product-item ' + soldOutClass + ' ' + saleClass + '" id="product-' + data.id + '"><div class="inner-top">';
  
  itemHtml += productTopGridTemp(data, soldOut, onSale);
  

  itemHtml += productBottomGridTemp(data, onSale);
  if ( theme.strings.productReviews ) {
    itemHtml += '<span class="shopify-product-reviews-badge" data-id="' + data.id + '}"></span>';
  }
  itemHtml += productActionTemp(data, soldOut);
  var hasFreeShippingTag = data.tags.indexOf('Free') > -1,
      hasFreeShippingPrice = data.variants[0].price > bcSfFilterConfig.general.free_shipping_price_threshold;
  if ( hasFreeShippingTag || hasFreeShippingPrice ) {
    itemHtml += '<label ' + multiLangDataTranslate('products.product.free_shipping') + ' class="free-shipping">' + '<i class="fa fa-truck"></i>Free Shipping</label>';
  }

  itemHtml += '</div></div>';
  itemHtml += '</div>';

  return itemHtml;
};
// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
  data = prepareShopifyData(data);
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  var itemHtml = '';
  var parentBCDiv = document.getElementById('bc-sf-filter-products');

  if ( parentBCDiv.className.indexOf('products-grid row') > -1 ) {
    parentBCDiv.className = 'product-collection product-list';
  }

  itemHtml += '<div class="product-item grid-item ' + soldOutClass + ' ' + saleClass + '" id="product-' + data.id + '">';
  itemHtml += productLeftGridTemp(data, soldOut, onSale);
  itemHtml += productRightGridTemp(data);
  itemHtml += '</div>';

  return itemHtml;
  // End For List View
};
/************************** END BUILD PRODUCT LIST **************************/

/************************** CUSTOM BUILD THEME PRODUCT ITEM ELEMENT **************************/
var multiLangDataTranslate = function (dataLabel) {
  return (theme.strings.multiLang ? 'data-translate="' + dataLabel + '"' : '');
};

var dataURLFormat = function (url) {
  var theUrl = '';
  if ( theme.strings.template === 'collection' ) {
    theUrl = '/collections/' + collectionHandle + url;
  } else {
    theUrl = url;
  }

  return theUrl;
};

var prodImgTag = function (data) {
  var imgSwp = '';
  var imgTags = '';
  var imgOpt = {};
  var noImgPlcHdr = '//cdn.shopify.com/s/files/1/0024/8617/3749/t/4/assets/bc-sf-filter-no-image.gif?4754752330844039870';
  var featuredImg = '';

  if ( data.featured_image != null ) {
    if ( data.featured_image.src ) {
      featuredImg = data.featured_image.src;
    } else {
      featuredImg = data.featured_image;
    }
  } else {
    featuredImg = noImgPlcHdr;
  }

  var imgAutoResize = function(imgUrl) {
    var imgUrlText = '';
    if (imgUrl.indexOf('.jpg') > 0) {
      imgUrlText = imgUrl.replace('.jpg', '_250x.jpg');
    } else if (imgUrl.indexOf('.jpeg') > 0) {
      imgUrlText = imgUrl.replace('.jpeg', '_250x.jpeg');
    } else if (imgUrl.indexOf('.png') > 0) {
      imgUrlText = imgUrl.replace('.png', '_250x.png');
    }

    return imgUrlText;
  }

  imgTags += '<a href="' + dataURLFormat(data.url) + '" class="product-grid-image" title="' + bcsffilter.slugify(data.title) + '">';

  // images
  // Check for theme setting ebay watermark, if it is null OR the if the string is not detected in the image's file name then continue as normal
  if (data.images.length > 1 && theme.strings.imageSwap && (window.theme.ebay_watermark_indicator === '' || data.images[1].src.toLowerCase().indexOf(window.theme.ebay_watermark_indicator.toLowerCase()) == -1) ) {
    // image-swap class
    imgSwp = 'image-swap';

    // images
    imgTags += '<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt="' + bcsffilter.slugify(data.title) + '"' +
               'class="images-one lazyload"' +
               'data-src="' + (data.images[0].src ? imgAutoResize(data.images[0].src) : noImgPlcHdr) + '"' +
               'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"' +
               'data-sizes="auto">' +
               '<div class="images-two">' +
                '<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt="' + bcsffilter.slugify(data.title) + '"' +
                  'class="lazyload"' +
                  'data-src="' + (data.images[1].src ? imgAutoResize(data.images[1].src) : noImgPlcHdr) + '"' +
                  'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"' +
                  'data-sizes="auto">' +
               '</div>';
  } else {
    imgTags += '<img src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt="' + bcsffilter.slugify(data.title) + '"' +
               'data-src="' + featuredImg + '"' +
               'class="images-one lazyload"' +
               'data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]"' +
               'data-sizes="auto">';
  }

  imgTags += '</a>';

  return imgOpt = {
    imgSwp: imgSwp,
    imgTags: imgTags
  };
};

var prodQuickViewTag = function (data) {
  var quickViewTag = '';

  // quick view
  if ( theme.strings.quickView ) {
    quickViewTag = '<div class="quickview-button">' +
          '<a href="javascript:void(0)" id="' + data.handle + '" ' +
            'title="' + bcSfFilterConfig.labels.quick_view + '"' +
            multiLangDataTranslate('products.product.quick_view') + '>' +
              '<span ' + multiLangDataTranslate('products.product.quick_view') + '>' +
                bcSfFilterConfig.labels.quick_view +
              '</span>' +
          '</a>' +
        '</div>';
  }

  return quickViewTag;
};

var prodLabelTag = function (data, isSoldOut, isOnSale) {
  var productLabel = '';
  if (window.theme && window.theme.settings && window.theme.settings.display_sold_out_label === false) {
    isSoldOut = false;
  }

  let eta_date_metafield_index = data.metafields.findIndex(m => m.namespace == "custom" && m.key == "eta_date");
  
 
   let eta_date = data.metafields[eta_date_metafield_index] ? " ETA : " + data.metafields[eta_date_metafield_index]['value'] : '';
 

  console.log({eta_date});
  productLabel += '<div class="product-label">';

  if (data.variants[0].inventory_policy === "continue" && data.variants[0].inventory_quantity <= 0) {
    productLabel += '<strong class="label preorder-label" ' + multiLangDataTranslate('products.product.preorder') + '>Pre Order '+eta_date+'</strong>';
  } else if (data.price == 0 || (data.tags.includes('COMING SOON') && data.variants[0].inventory_quantity <= 0)) {
    productLabel += '<strong class="label label-coming-soon" ' + multiLangDataTranslate('products.product.coming_soon') + '>Coming Soon '+eta_date+'</strong>';
  } else if ( isOnSale ) {
    productLabel += '<strong class="label label-sale" ' + multiLangDataTranslate('products.product.sale') + '>' + bcSfFilterConfig.label_basic.sale + '</strong>';
  }  else if ( data.tags.indexOf('New') > -1 ) {
    productLabel += '<strong class="label label-new">New</strong>';
  } /* else if ( isSoldOut ) {
    if ( window.theme.settings.display_sold_out_label ) {
      productLabel += '<strong class="label sold-out-label" ' + multiLangDataTranslate('products.product.sold_out') + '>' + bcSfFilterConfig.label_basic.sold_out + '</strong>';
    } else {
      productLabel += '<strong class="label"></strong>';
    }
  }  else if ( !isSoldOut ) {
    if ( window.theme.settings.display_sold_out_label ) {
      productLabel += '<strong class="label label-in-stock">In Stock</strong>';
    } else {
      productLabel += '<strong class="label"></strong>';
    }
  }*/

  productLabel += '</div>';

  return productLabel;

};

var prodItemSwatchTag = function (data) {
  var prodItemSwatch = '';
  var hasSwatch = false;
  var colorList = [];
  var theColor = '';
  var theOptionIndex = 0;
  var swatchItem = '';

  for (var x = 0; x < data.options.length; x++) {
    if ( data.options[x].toLowerCase() === 'color' || data.options[x].toLowerCase() === 'colour' ) {
      hasSwatch = true;
      theOptionIndex = x;
      break;
    }
  }

  if ( hasSwatch ) {
    for (var y = 0; y < data.variants.length; y++) {
      var variantColor = data.variants[y].options[theOptionIndex].trim().toLowerCase();

      if ( colorList.indexOf(variantColor) <= -1) {
        swatchItem += '<li><label style="';
        if ( variantColor === 'white' ) {
          swatchItem += 'border: 1px solid #cbcbcb;';
        }
        swatchItem += 'background-color: ' + variantColor + ';';
        swatchItem += 'background-image: url(' + defaultFileUrl[0] + variantColor + '.png?' + defaultFileUrl[1] + ');"></label>';
        if ( data.variants[y].image != null ) {
          swatchItem += '<div class="hidden"><a href="' + data.variants[y].image + '"></a></div>';
        }
        swatchItem += '</li>';

        colorList.push(variantColor);
      }
    }    
  }

  prodItemSwatch += '<ul class="item-swatch">';
  prodItemSwatch += swatchItem;
  prodItemSwatch += '</ul>';

  return prodItemSwatch;
};

var prodLinkTemp = function (data) {
  var productLink = '';

  // Product Link
  productLink = '<div class="product-title-code">';
  productLink += '<a class="product-title" href="' + dataURLFormat(data.url) + '">';
  if ( theme.strings.multiLang ) {
    productLink += '<span class="lang1">' + data.title.split('|')[0] + '</span>';
    productLink += '<span class="lang2">' + data.title.split('|')[data.title.split('|').length - 1] + '</span>';
  } else {
    productLink += data.title.split('|')[0];
  }
  productLink += '</a>';
  
  if (data.skus != null){
    productLink += '<div class="product-code">';
    productLink += '<span class="product-code-label">' + bcSfFilterConfig.custom.product_code_label + '</span>';
    productLink += '<span class="productSkuCode">' + data.skus[0] + '</span>';
    productLink += '</div>';
  }
  productLink += '</div>';

  return productLink;
};

var priceBoxTemp = function (data, isOnSale) {
  var priceBox = '';
  var salePrice = '';
  var lowestVariantPrice = 0;
  var lowestPriceCompare = 0;

  if (data.variants.length > 1) {
    for (var x = 0; x < data.variants.length; x++) {
      if (data.variants[x].price != 0) {
        if (lowestVariantPrice == 0) {
          lowestVariantPrice = data.variants[x].price;
        }
        if (data.variants[x].price < lowestVariantPrice) {
          lowestVariantPrice = data.variants[x].price;
          lowestPriceCompare = data.variants[x].compare_at_price;
        }
      }
    }
  } else {
    lowestVariantPrice = data.price_min;
    lowestPriceCompare = data.compare_at_price_min;
  }

  // Price Box
  priceBox = '<div class="price-box">';
  if ( data.price <= 0 && data.variants.length == 1) {
    salePrice += '<span>';
    salePrice += bcSfFilterConfig.custom.price_coming_soon;
    salePrice += '</span>';
  }
  else if ( isOnSale ) {
    salePrice += '<p class="sale">';
    salePrice += '<span class="old-price">'+ bcsffilter.formatMoney(lowestPriceCompare) +'</span>';
    salePrice += '<span class="special-price">';
    if ( data.price_varies ) {
      salePrice += '<em ' + multiLangDataTranslate('products.product.from') + '>' + bcSfFilterConfig.labels.product_from + '</em>';
    }
    salePrice += bcsffilter.formatMoney(lowestVariantPrice) + '</span>';
    salePrice +='</p>'
  } else {
    salePrice += '<div class="regular-product">';
    salePrice += '<span>';
    if ( data.price_varies ) {
      salePrice += '<em ' + multiLangDataTranslate('products.product.from') + '>' + bcSfFilterConfig.labels.product_from + '</em>';
    }
    salePrice += bcsffilter.formatMoney(lowestVariantPrice) + '</span>';
    salePrice += '</div>';
  }
  priceBox += salePrice;
  priceBox += '</div>';

  return priceBox;
};

var prodDescriptionTemp = function (data) {
  var prodDescTempString = '<div class="short-description">';
  var shortDesc = '';

  if ( data.description.indexOf('[countdown]') > -1 ) {
    shortDesc = data.description.split('[/countdown]')[data.description.split('[/countdown]').length - 1];
  } else {
    shortDesc = data.description;
  }

  if ( theme.strings.multiLang ) {
    prodDescTempString += '<span class="lang1">' + shortDesc.split('[lang2]')[0].replace (/&#{0,1}[a-z0-9]+;/ig, "").substring(0, 43); + '</span>';
    prodDescTempString += '<span class="lang2">' + shortDesc.split('[lang2]')[shortDesc.split('[lang2]').length - 1].replace (/&#{0,1}[a-z0-9]+;/ig, "").substring(0, 43); + '</span>';
  } else {
    prodDescTempString += shortDesc.split('[lang2]')[0].replace (/&#{0,1}[a-z0-9]+;/ig, "").substring(0, 43);
  }

  prodDescTempString += '</div>';

  return prodDescTempString;
};

var productActionTemp = function (data, isSoldOut) {
  var prodActTempString = '<div class="action" id="product-actions-' + data.id + '">';

  prodActTempString += '<form action="/cart/add" method="post" class="variants">';
    if (data.variants[0].inventory_policy === "continue" && data.variants[0].inventory_quantity <= 0) {
    prodActTempString += '<input type="hidden" name="id" value="' + data.variants[0].id + '" />';
    prodActTempString += '<input class="btn add-to-cart-btn preorder-btn" type="submit" value="Pre Order" ' + multiLangDataTranslate('products.product.preorder') + '/>';
  } else if (data.price == 0 || (data.tags.includes('COMING SOON') && data.variants[0].inventory_quantity <= 0)) {
    prodActTempString += '<input class="btn add-to-cart-btn" type="submit" value="Coming Soon" disabled="disabled"' + 
          multiLangDataTranslate('products.product.coming_soon') + '/>';
  } else if ( isSoldOut ) {
    prodActTempString += '<input class="btn add-to-cart-btn" type="submit" value="' + bcSfFilterConfig.label_basic.sold_out + '" disabled="disabled"' + 
          multiLangDataTranslate('products.product.unavailable') + '/>';
  } else {
    if ( data.variants.length > 1 ) {
      prodActTempString += '<input class="btn" type="button" onclick="window.location.href=' + data.url + '" value="' + 
          bcSfFilterConfig.labels.select_options + '" ' + multiLangDataTranslate('products.product.select_options') + '/>';
    } else {
      prodActTempString += '<input type="hidden" name="id" value="' + data.variants[0].id + '" />';
      prodActTempString += '<input class="btn add-to-cart-btn" type="submit" value="Add To Cart" />';
    }
  }

  prodActTempString += '</form>';

  prodActTempString += '</div>';  

  return prodActTempString;
};

var productTopGridTemp = function (data, isSoldOut, isOnSale) {
  var prodTopTempString = '<div class="product-top">';
  var prodImg = prodImgTag(data);
  var prodQuickView = prodQuickViewTag(data);
  var prodLabel = prodLabelTag(data, isSoldOut, isOnSale);
  var prodSwatch = prodItemSwatchTag(data);

  prodTopTempString += '<div class="product-image ' + prodImg.imgSwp + '">';
  prodTopTempString += prodImg.imgTags;
  prodTopTempString += prodQuickView;
  prodTopTempString += '</div>';
  prodTopTempString += prodLabel;
  prodTopTempString += '</div>';
  prodTopTempString += '<div class="product-des">';
  if ( theme.strings.wishList ) {
    prodTopTempString += '<div class="addwishlist"><a class="action--wishlist wishlist-btn" href="#" data-product-handle="' + data.handle + '"><i class="fa fa-heart-o "></i></a></div>';
  }
  if ( theme.strings.itemSwatch ) {
    prodTopTempString += prodSwatch;
  }
  prodTopTempString += '</div>';

  return prodTopTempString;
};

var productBottomGridTemp = function (data, isOnSale) {
  var prodBotTempString = '<div class="product-bottom">';
  var prodLink = prodLinkTemp(data);
  var priceBx = priceBoxTemp(data, isOnSale);

  prodBotTempString += prodLink;
  prodBotTempString += priceBx;
  prodBotTempString += '</div>';

  return prodBotTempString;
};

var productLeftGridTemp = function (data, isSoldOut, isOnSale) {
  var prodLeftTempString = '<div class="column_left">';
  var prodImg = prodImgTag(data);
  var prodLabel = prodLabelTag(data, isSoldOut, isOnSale);
  var prodQuickView = prodQuickViewTag(data);
  var prodSwatch = prodItemSwatchTag(data);

  prodLeftTempString += '<div class="product-image ' + prodImg.imgSwp + '">';
  prodLeftTempString += prodImg.imgTags;
  prodLeftTempString += prodLabel;
  prodLeftTempString += prodQuickView;
  prodLeftTempString += '</div>';
  if ( theme.strings.itemSwatch ) {
    prodLeftTempString += prodSwatch;
  }

  prodLeftTempString += '</div>';

  return prodLeftTempString;
};

var productRightGridTemp = function (data, isSoldOut, isOnSale) {
  var prodRightTempString = '<div class="column_right"><div class="product-details">';
  var prodLink = prodLinkTemp(data);
  var priceBx = priceBoxTemp(data, isOnSale);
  var prodDesc = prodDescriptionTemp(data);

  if ( theme.strings.showVendor ) {
    prodRightTempString += '<span class="product-vendor">' + data.vendor + '</span>';
  }
  prodRightTempString += prodLink;
  prodRightTempString += priceBx;
  prodRightTempString += prodDesc;
  if ( theme.strings.productReviews ) {
    prodRightTempString += '<span class="shopify-product-reviews-badge" data-id="' + data.id + '}"></span>';
  }
  prodRightTempString += productActionTemp(data, soldOut);
  if ( theme.strings.wishList ) {
    prodRightTempString += '<div class="addwishlist"><a class="action--wishlist wishlist-btn" href="#" data-product-handle="' + data.handle + '">' + bcSfFilterConfig.labels.add_to_wishlist + '</i></a></div>';
  }
  var hasFreeShippingTag = data.tags.indexOf(bcSfFilterConfig.labels.label_free) > -1,
      hasFreeShippingPrice = data.variants[0].price > bcSfFilterConfig.general.free_shipping_price_threshold;
  if ( hasFreeShippingTag || hasFreeShippingPrice ) {
    prodRightTempString += '<label ' + multiLangDataTranslate('products.product.free_shipping') + ' class="free-shipping">' + '<i class="fa fa-truck"></i>' + bcSfFilterConfig.labels.free_shipping + '</label>';
  }

  prodRightTempString += '</div></div>';

  return prodRightTempString;
};

/************************** END CUSTOM BUILD THEME PRODUCT ITEM ELEMENTS **************************/


/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
function buildGridWidthClass() {
  var gridWidthClass = '';
  // On PC
  switch (bcSfFilterConfig.custom.products_per_row) {
    case 2:
      gridWidthClass = 'bc-sf-filter-grid-width-2';
      break;
    case 3:
      gridWidthClass = 'bc-sf-filter-grid-width-3';
      break;
    case 5:
      gridWidthClass = 'bc-sf-filter-grid-width-5';
      break;
    default:
      gridWidthClass = 'bc-sf-filter-grid-width-4';
      break;
  }
  // On Mobile
  switch (bcSfFilterConfig.custom.products_per_row_mobile) {
    case 1:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-1';
      break;
    case 3:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-3';
      break;
    default:
      gridWidthClass += ' bc-sf-filter-grid-width-mb-2';
      break;
  }
  return gridWidthClass;
}

function buildImages(data) {
  var html = '';
  // Build Main Image
  var thumbUrl = images.length > 0 ? bcsffilter.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
  html += '<img src="' + thumbUrl + '" class="bc-sf-filter-product-item-main-image" />';
  // Build Image Swap
  if (bcSfFilterConfig.custom.active_image_swap) {
    var flipImageUrl = images.length > 1 ? bcsffilter.optimizeImage(images[1]['src']) : thumbUrl;
    html += '<img src="' + flipImageUrl + '" class="bc-sf-filter-product-item-flip-image" />';
  }
  return html;
}

function buildVendor(data) {
  var html = '';
  if (bcSfFilterConfig.custom.show_vendor) {
    html = bcSfFilterTemplate.vendorHtml;
  }
  return html;
}

function buildPrice(data) {
  var html = '';
  if (bcSfFilterConfig.custom.show_price) {
    html = '<p class="bc-sf-filter-product-item-price">';
    if (onSale) {
      html += '<s>' + bcsffilter.formatMoney(data.compare_at_price_min) + '</s> ';
      html += '<span class="bc-sf-filter-product-item-sale-price">' + bcsffilter.formatMoney(data.price_min) + '</span>';
    } else {
      if (priceVaries) {
        html += (bcSfFilterConfig.label_basic.from) + ' ';
      }
      html += '<span class="bc-sf-filter-product-item-regular-price">' + bcsffilter.formatMoney(data.price_min) + '</span>';
    }
    html += '</p>';
  }
  return html;
}

function buildLabels(data) {
  // Build Sold out label
  var soldOutLabel = '';
  if (bcSfFilterConfig.custom.show_sold_out_label && soldOut) {
    soldOutLabel = bcSfFilterTemplate.soldOutLabelHtml.replace(/{{style}}/g, '');
  }
  // Build Sale label
  var saleLabel = '';
  if (bcSfFilterConfig.custom.show_sale_label && onSale && !soldOut) {
    saleLabel = bcSfFilterTemplate.saleLabelHtml.replace(/{{style}}/g, '');
  }
  // Build Labels
  return soldOutLabel + saleLabel;
}
// BUILD LABEL PRODUCT WITH TAGS
function buildTagLabels(data, showall) {
  if (showall) {
    var tagLabel = '';
    if (data.tags) {
      for (var i = 0; i < data.tags.length; i++) {
        var tag = data.tags[i];
        if (tag.indexOf("pfs:label") !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
          tagLabel += preTagLabel;
        }
      }
    }
  } else {
    var tagLabel = '';
    if (data.tags) {
      for (var i = data.tags.length - 1; i >= 0; i--) {
        tag = data.tags[i];
        if (tag.indexOf("pfs:label") !== -1) {
          var preTagLabel = bcSfFilterTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
          tagLabel += preTagLabel;
          break;
        }
      }
    }
  }
  return tagLabel;
}
/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
/************************** BUILD TOOLBAR **************************/
// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  // Get page info
  var currentPage = parseInt(this.queryParams.page);
  var totalPage = Math.ceil(totalProduct / this.queryParams.limit);
  // If it has only one page, clear Pagination
  if (totalPage == 1) {
    jQ(this.selector.pagination).html('');
    return false;
  }
  if (this.getSettingValue('general.paginationType') == 'default') {
    var paginationHtml = bcSfFilterTemplate.paginateHtml;
    // Build Previous
    var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
    previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
    paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
    // Build Next
    var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
    nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
    paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
    // Create page items array
    var beforeCurrentPageArr = [];
    for (var iBefore = currentPage - 2; iBefore > currentPage - 2 && iBefore > 0; iBefore--) {
      beforeCurrentPageArr.unshift(iBefore);
    }
    if (currentPage - 2 > 0) {
      beforeCurrentPageArr.unshift('...');
    }
    if (currentPage - 2 >= 0) {
      beforeCurrentPageArr.unshift(1);
    }
    beforeCurrentPageArr.push(currentPage);
    var afterCurrentPageArr = [];
    for (var iAfter = currentPage + 1; iAfter < currentPage + 2 && iAfter <= totalPage; iAfter++) {
      afterCurrentPageArr.push(iAfter);
    }
    if (currentPage + 2 < totalPage) {
      afterCurrentPageArr.push('...');
    }
    if (currentPage + 2 <= totalPage) {
      afterCurrentPageArr.push(totalPage);
    }
    // Build page items
    var pageItemsHtml = '';
    var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
    for (var iPage = 0; iPage < pageArr.length; iPage++) {
      if (pageArr[iPage] == '...') {
        pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
      } else {
        pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
      }
      pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
      pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
    }
    paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
    jQ(this.selector.pagination).html(paginationHtml);
  }
};
// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterConfig.custom.show_sorting && bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');
    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ(this.selector.topSorting).html(html);
      // Set current value
      jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
    }
  }
};
// For Toolbar - Build Display type
BCSfFilter.prototype.buildFilterDisplayType = function() {
  var itemHtml = '<span>' + bcSfFilterConfig.labels.toolbar_viewas + '</span>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="bc-sf-filter-display-item bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
  itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="bc-sf-filter-display-item bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  topDisplayTypeSelector.html(itemHtml);
  // Active current display type
  topDisplayTypeSelector.find('.bc-sf-filter-display-item').removeClass('active');
  if (this.queryParams.display == 'list') {
    topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
    listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
  } else if (this.queryParams.display == 'grid') {
    topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
    listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
  }
};
// Build Display type event
BCSfFilter.prototype.buildDisplayTypeEvent = function() {
  var _this = this;
  var topDisplayTypeSelector = jQ(this.getSelector('topDisplayType'));
  var listProductSelector = jQ(this.getSelector('products'));
  jQ(this.getSelector('topDisplayType') + ' a').click(function(e) {
    e.preventDefault();
    _this.internalClick = true;
    jQ(this).parent().children().removeClass('active');
    jQ(this).addClass('active');
    if (_this.queryParams.display == 'list') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-list').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-grid-view-items').addClass('bc-sf-filter-list-view-items');
    } else if (_this.queryParams.display == 'grid') {
      topDisplayTypeSelector.find('.bc-sf-filter-display-grid').addClass('active');
      listProductSelector.removeClass('bc-sf-filter-list-view-items').addClass('bc-sf-filter-grid-view-items');
    }
    var newUrl = jQ(this).attr('href');
    _this.onChangeData(newUrl, 'display');
  })
};
// Build Show Limit
BCSfFilter.prototype.buildFilterShowLimit = function() {
  if (bcSfFilterConfig.custom.show_limit && bcSfFilterTemplate.hasOwnProperty('showLimitHtml')) {
    jQ(this.selector.topShowLimit).html('');
    var numberList = this.getSettingValue('general.showLimitList');
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = '';
      var arr = numberList.split(',');
      for (var k = 0; k < arr.length; k++) {
        showLimitItemsHtml += '<option value="' + arr[k].trim() + '">' + arr[k].trim() + '</option>';
      }
      var html = bcSfFilterTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
      jQ(this.selector.topShowLimit).html(html);
      // Set value
      jQ(this.selector.topShowLimit + ' select').val(this.queryParams.limit);
    }
  }
};
// Build Breadcrumb
BCSfFilter.prototype.buildBreadcrumb = function(colData, apiData) {
  if (bcSfFilterTemplate.hasOwnProperty('breadcrumbHtml')) {
    var breadcrumbItemsHtml = '';
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
      var colInfo = colData.collection;
      if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
        breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
      } else {
        breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
      }
    } else {
      breadcrumbItemsHtml += bcSfFilterTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.getSettingValue('label.defaultCollectionHeader'));
    }
    var html = bcSfFilterTemplate.breadcrumbHtml.replace(/{{breadcrumbItems}}/g, breadcrumbItemsHtml)
    html = html.replace(/{{breadcrumbDivider}}/g, bcSfFilterTemplate.breadcrumbDivider);
    jQ(this.selector.breadcrumb).html(html);
  }
};
/************************** END BUILD TOOLBAR **************************/
function matchHeightImage() {
  jQ('.bc-sf-filter-product-item-main-image').load(function() {
    var imageContainer = jQ(this).parent();
    imageContainer.css('width', '100%').css('height', $(this).height());
  }).each(function() {
    if (this.complete) jQ(this).load();
  });
}
// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {
  // Call theme init function
  if (typeof theme !== 'undefined' && typeof theme.init === 'function') {
    $(theme.init);
  }
  // End For List View
};
// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  var _this = this;
  var totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.labels.items_with_count_other + '</span>';
  if (data.total_product == 1) {
    totalProduct = data.total_product + '<span> ' + bcSfFilterConfig.labels.items_with_count_one + '</span>';
  }
  jQ('#bc-sf-filter-total-product').html(totalProduct);
  matchHeightImage();
  $('.product-title-code').matchHeight();
  jQ(window).resize(function() {
    matchHeightImage();
  });
};


    // Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

    // Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data};

BCSfFilter.prototype.buildDefaultPaginationEvent = function(a) {
  var self = this;
  parseInt(this.queryParams.page);
  jQ(this.getSelector("pagination")).find("a").off("click").on("click", function (event) {
    event.preventDefault();
    self.internalClick = true;

    var href = jQ(this).attr("href");


    var hasFixtopMenu = window.theme
        && window.theme.sections
        && window.theme.sections.navigation
        && window.theme.sections.navigation.settings
        && window.theme.sections.navigation.settings.display_fixtop_menu;

    var $section = jQ("#shopify-section-collection-template-bc-sf-filter"),
        $header = jQ("#main-header-block");

    var scrollTop = (hasFixtopMenu && $section.length && $header.length) ? $section.offset().top - $header.outerHeight() : jQ(self.getSelector("products")).position().top;

    self.onChangeData(href, "page");
    jQ("body, html").animate({
      scrollTop: scrollTop
    }, 600);
  });
};


// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}


// Prepare Params of Filter / Search API
BCSfFilter.prototype.prepareRequestParams = function(eventType) {
    var params = mergeObject({}, this.queryParams);
    // Get Filter params
    params = this.prepareFilterParams(params, eventType);
    // Search Page: Get Search params
    params = this.prepareSearchParams(params, eventType);
  
  	if(available_first_categories.includes(params.collection_scope)){
      params.sort_first = 'available';
    }
  
    // Set data back to queryParams
    this.queryParams = params;
};

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
